module.exports = __webpack_public_path__ + "img/calendar-arrow-down.c0b5840c.svg";